import {Directive, ElementRef, Host, HostListener} from '@angular/core';
import {NgModel} from '@angular/forms';
import {first} from 'rxjs/operators';

@Directive({
  selector: '[ibanMask]'
})
export class IbanMaskDirective {

  constructor(private el: ElementRef, @Host() private ngModel: NgModel) {
    this.ngModel.valueChanges.pipe(first()).subscribe(() => this.reformatInputField());
  }

  @HostListener('input')
  onInput() {
    this.reformatInputField();
  }

  reformatInputField() {
    const position = this.el.nativeElement.selectionEnd;
    const previousValue = this.el.nativeElement.value;
    this.el.nativeElement.value = this.format(this.el.nativeElement.value);

    if (position !== this.el.nativeElement.value.length) {
      const beforeCaret = previousValue.substr(0, position);
      const countPrevious = this.countSpaces(beforeCaret);
      const countCurrent = this.countSpaces(this.format(beforeCaret));
      this.el.nativeElement.selectionEnd = position + (countCurrent - countPrevious);
    }
  }

  countSpaces(text) {
    const spaces = text.match(/(\s+)/g);
    return spaces ? spaces.length : 0;
  }

  format(value) {
    return value.replace(/[^\dA-Z]/gi, '')
      .toUpperCase()
      .replace(/(.{4})/g, '$1 ')
      .trim();
  }

}
